import { render } from "./DesignPreQuestionModal.vue?vue&type=template&id=651abaea&scoped=true&ts=true"
import script from "./DesignPreQuestionModal.vue?vue&type=script&lang=ts"
export * from "./DesignPreQuestionModal.vue?vue&type=script&lang=ts"

import "./DesignPreQuestionModal.vue?vue&type=style&index=0&id=651abaea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651abaea"]])

export default __exports__